import { render, staticRenderFns } from "./RegistrationExistingUser.vue?vue&type=template&id=5a5d0861&scoped=true"
import script from "./RegistrationExistingUser.vue?vue&type=script&lang=js"
export * from "./RegistrationExistingUser.vue?vue&type=script&lang=js"
import style0 from "./RegistrationExistingUser.vue?vue&type=style&index=0&id=5a5d0861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d0861",
  null
  
)

export default component.exports